import { http } from '../plugins/http'

class PublicService {
  simulatePrice(billPlan, periodicity, nbActiveUsers, date) {
    return http.get(`/public/simulate/price/${billPlan}/${periodicity}/${nbActiveUsers}/${date}`);
  }
}

export default new PublicService();